module.exports = __webpack_public_path__ + "img/16-image-1-1@2x.c8e50336.png";